// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#SearchResults .flexColumn {
    width: 75vw;
}

#SearchResults>.dropDown {
    position: fixed;
    top: 10px;
    right: 10px;
}

#SearchResults .searchResult {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 10px;
}

#SearchResults .searchResultThumbnailMeta {
    display: flex;
}

#SearchResults .searchResultThumbnail {
    width: 25%;
    max-width: 250px;
    background-size: cover;
    align-self: stretch;
    background-position: center;
    position: relative;
    border: 1px solid #ddd;
    border-radius: 5px;
}

#SearchResults .searchResultDuration {
    position: absolute;
    bottom: 0;
    right: 0;
    background: #444;
    color: #fff;
    padding: 3px 8px;
}

#SearchResults .searchResultDetails {
    padding-left: 20px;
    flex: 1 1;
}

#SearchResults .searchResultDescriptor {
    background: black;
    border-radius: 5px;
    padding: 2px 4px;
    color: white;
    margin: 0 3px;
    font-weight: bold;
}

#SearchResults .searchResultDescriptor:first-child {
    margin-left: 0;
}

#SearchResults .searchResultDescriptor.blue {
    background: #1f96ff;
}

#SearchResults .searchResultDescriptor.red {
    background: #f20000;
}

#SearchResults .searchResultDescriptor.violet {
    background: #9300d6;
}

#SearchResults .recordingDescription {
    font-size: 20px;
}

#SearchResults .nextPrevPage {
    color: #bbb;
}

#SearchResults .nextPrevPage.active {
    color: #1faeff;
    cursor: pointer;
}

#SearchMeta .dropDown {
    position: relative;
    top: none;
    right: none;
}

#SearchMeta>div {
    margin: 10px 0;
    font-size: 16px;
}

#SearchMeta select {
    font-size: 16px;
}

#DropDownsContainer .dropDown {
    z-index: 1;
    display: inline-block;
    top: 0;
    right: 0;
}

#SearchResults .labelledInputContainer {
    margin: 5px;
}

#SearchResults .additionalInputsContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
}`, "",{"version":3,"sources":["webpack://./src/Magor/searchResults.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC","sourcesContent":["#SearchResults .flexColumn {\n    width: 75vw;\n}\n\n#SearchResults>.dropDown {\n    position: fixed;\n    top: 10px;\n    right: 10px;\n}\n\n#SearchResults .searchResult {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding: 10px;\n}\n\n#SearchResults .searchResultThumbnailMeta {\n    display: flex;\n}\n\n#SearchResults .searchResultThumbnail {\n    width: 25%;\n    max-width: 250px;\n    background-size: cover;\n    align-self: stretch;\n    background-position: center;\n    position: relative;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\n#SearchResults .searchResultDuration {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background: #444;\n    color: #fff;\n    padding: 3px 8px;\n}\n\n#SearchResults .searchResultDetails {\n    padding-left: 20px;\n    flex: 1;\n}\n\n#SearchResults .searchResultDescriptor {\n    background: black;\n    border-radius: 5px;\n    padding: 2px 4px;\n    color: white;\n    margin: 0 3px;\n    font-weight: bold;\n}\n\n#SearchResults .searchResultDescriptor:first-child {\n    margin-left: 0;\n}\n\n#SearchResults .searchResultDescriptor.blue {\n    background: #1f96ff;\n}\n\n#SearchResults .searchResultDescriptor.red {\n    background: #f20000;\n}\n\n#SearchResults .searchResultDescriptor.violet {\n    background: #9300d6;\n}\n\n#SearchResults .recordingDescription {\n    font-size: 20px;\n}\n\n#SearchResults .nextPrevPage {\n    color: #bbb;\n}\n\n#SearchResults .nextPrevPage.active {\n    color: #1faeff;\n    cursor: pointer;\n}\n\n#SearchMeta .dropDown {\n    position: relative;\n    top: none;\n    right: none;\n}\n\n#SearchMeta>div {\n    margin: 10px 0;\n    font-size: 16px;\n}\n\n#SearchMeta select {\n    font-size: 16px;\n}\n\n#DropDownsContainer .dropDown {\n    z-index: 1;\n    display: inline-block;\n    top: 0;\n    right: 0;\n}\n\n#SearchResults .labelledInputContainer {\n    margin: 5px;\n}\n\n#SearchResults .additionalInputsContainer {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
